<template>
  <div class="main">
    <div class="meeting-card">
      
      <div class="meeting-info-section">
        <div class="meeting-details">
          <div class="detail-item">
            <span class="detail-label">会议名称：</span>
            <a-input v-model:value="meetingForm.meetingName" placeholder="请输入会议名称" class="meeting-name-input" />
          </div>
            
          <div class="detail-item">
            <span class="detail-label">会议日期：</span>
            <a-date-picker v-model:value="meetingForm.meetingDate" style="width: 220px;" format="YYYY-MM-DD" placeholder="选择会议日期" />
          </div>
          
          <div class="detail-item">
            <span class="detail-label">会议评审结果：</span>
            <span class="detail-value">
              <div class="radio-group-wrapper">
                <a-radio-group v-model:value="meetingForm.reviewResult">
                  <a-radio :value="1">通过</a-radio>
                  <a-radio :value="0">未通过</a-radio>
                </a-radio-group>
              </div>
            </span>
          </div>
          
          <div class="detail-item full-width" style="align-items: flex-start;">
            <span class="detail-label" style="align-self: flex-start; margin-top: 4px;">会议纪要：</span>
            <div class="detail-value" style="align-self: flex-start; margin-top: 4px;">
              <a-textarea v-model:value="meetingForm.meetingSummary" :rows="3" placeholder="请输入会议纪要" />
            </div>
          </div>
          
          <div class="detail-item full-width" style="align-items: flex-start;">
            <span class="detail-label" style="align-self: flex-start; margin-top: 4px;">专家组意见：</span>
            <div class="detail-value" style="align-self: flex-start; margin-top: 4px;">
              <a-textarea v-model:value="meetingForm.expertOpinion" :rows="3" placeholder="请输入专家组意见" />
            </div>
          </div>
        </div>

        <div class="meeting-attachment-section">
          <div class="attachment-header">
            <h4>会议附件</h4>
          </div>
          <div class="attachment-content">
            <MaterialFileManager
                :materialId="'new-meeting'"
                :initialFiles="meetingForm.attachments || []"
                :edit="true"
                @update:files="(files, materialId) => handleFilesUpdate(materialId, files)"
                @upload-success="handleUploadSuccess"
                @delete="handleFileDelete"
            />
          </div>
        </div>
      </div>

      <div class="action-section">
        <div class="action-buttons">
          <a-button @click="handleBack">返回</a-button>
          <a-button type="primary" @click="submitMeeting">创建会议</a-button>
        </div>
      </div>
    </div>

    <div class="selected-applications">
      <div class="section-header">
        <h3>选中的申请信息</h3>
      </div>
      <a-table :columns="selectedColumns" :row-key="(record) => record.id"
               :data-source="selectedApplications" size="middle"
               :pagination="false" :scroll="{ y: 'auto' }"
               v-autoHeight="{ extraHeight: 0, trHeight: 40 }">
        <template #bodyCell="{ column, record }">
          <template v-if="column.key === 'testTime'">
            {{ record.startDate }} 至 {{ record.endDate }}
          </template>
          <template v-if="column.key === 'status'">
            {{ getStatusView(record.status) }}
          </template>
        </template>
      </a-table>
    </div>
  </div>
</template>
<script setup>
import { ref, reactive, onMounted } from "vue";
import { useRouter } from "vue-router";
import { createReviewMeeting } from "@/api/application/reviewMeetings"
import { getStatusView } from '@/utils/applicationUtils'
import { Modal, message } from 'ant-design-vue';
import MaterialFileManager from '@/components/MaterialFileManager/index.vue';

const router = useRouter();

const meetingForm = reactive({
  meetingName: '',
  meetingDate: null,
  actualStartTime: null,
  actualEndTime: null,
  reviewResult: null,
  meetingSummary: '',
  expertOpinion: '',
  attachments: []
});

const selectedApplications = ref([]);

const selectedColumns = [
  {
    title: "申请编号",
    dataIndex: "applicationNo",
    key: "applicationNo",
    width: 200,
  },
  {
    title: "企业名称",
    dataIndex: "deptName",
    key: "deptName",
    width: 180,
  },
  {
    title: "申请类型",
    dataIndex: "categoryName",
    key: "categoryName",
  },
  {
    title: "车辆识别代码",
    dataIndex: "vin",
    key: "vin",
    width: 200,
  },
  {
    title: "申请有效期",
    key: "testTime",
    width: 220,
  },
  {
    title: "状态",
    dataIndex: "status",
    key: "status",
    width: 150,
  },
];

onMounted(() => {
  const storedData = sessionStorage.getItem('selectedApplications');
  if (storedData) {
    selectedApplications.value = JSON.parse(storedData);
    sessionStorage.removeItem('selectedApplications');
  }
});

const handleBack = () => {
  router.push('/application/index');
};

const handleFilesUpdate = (materialId, files) => {
  meetingForm.attachments = files;
};

const handleUploadSuccess = (file, materialId) => {
  if (!Array.isArray(meetingForm.attachments)) {
    meetingForm.attachments = [];
  }
  const existingFileIndex = meetingForm.attachments.findIndex(f => f.id === file.id);
  if (existingFileIndex === -1) {
    meetingForm.attachments.push(file);
  } else {
    meetingForm.attachments[existingFileIndex] = file;
  }
};

const handleFileDelete = (file, materialId) => {
  if (Array.isArray(meetingForm.attachments)) {
    meetingForm.attachments = meetingForm.attachments.filter(f => f.id !== file.id);
  }
};

const submitMeeting = async () => {
  if (!meetingForm.meetingName) {
    message.error('请输入会议名称');
    return;
  }
  
  if (!meetingForm.meetingDate) {
    message.error('请选择会议日期');
    return;
  }

  if (selectedApplications.value.length === 0) {
    message.error('没有选中的申请');
    return;
  }

  const applicationIds = selectedApplications.value.map(item => item.id);
  
  const data = {
    meetingName: meetingForm.meetingName,
    meetingDate: meetingForm.meetingDate.format('YYYY-MM-DD'),
    actualStartTime: meetingForm.actualStartTime ? meetingForm.actualStartTime.format('YYYY-MM-DD HH:mm:ss') : null,
    actualEndTime: meetingForm.actualEndTime ? meetingForm.actualEndTime.format('YYYY-MM-DD HH:mm:ss') : null,
    reviewResult: meetingForm.reviewResult,
    meetingSummary: meetingForm.meetingSummary,
    expertOpinion: meetingForm.expertOpinion,
    applicationIds: applicationIds,
    attachments: meetingForm.attachments
  };

  try {
    const response = await createReviewMeeting(data);
    if (response.code === 200) {
      message.success('会议创建成功');
      router.push('/application/index');
    } else {
      message.error(response.message || '创建失败');
    }
  } catch (error) {
    console.error('创建会议失败:', error);
    message.error('创建会议失败，请重试');
  }
};
</script>

<style lang="less" scoped>
.main {
  padding: 20px;
  background-color: #f5f5f5;
}

.meeting-card {
  border: 1px solid #e8e8e8;
  border-radius: 6px;
  overflow: hidden;
  background: #fff;
  margin-bottom: 20px;
}

.meeting-name-input {
  flex: 1;
  max-width: 300px;
}

.meeting-info-section {
  padding: 20px;
}

.meeting-details {
  display: flex;
  flex-wrap: wrap;
  gap: 15px 50px;
}

.detail-item {
  display: flex;
  align-items: center;
}

.detail-item.full-width {
  min-width: 100%;
  width: 100%;
}

.detail-label {
  width: 120px;
  font-weight: 500;
  display: flex;
  align-items: center;
  color: #666;
  font-size: 14px;
  margin-right: 10px;
}

.detail-value {
  flex: 1;
  display: flex;
  align-items: center;
  color: #333;
  font-size: 14px;
  min-width: 150px;
}

.action-section {
  padding: 16px 20px;
  border-top: 1px solid #e8e8e8;
  background-color: #fafafa;
  display: flex;
  justify-content: flex-end;
}

.action-buttons {
  display: flex;
  gap: 12px;
}

.selected-applications {
  background: #fff;
  border: 1px solid #e8e8e8;
  border-radius: 6px;
  overflow: hidden;
}

.section-header {
  padding: 16px 20px;
  border-bottom: 1px solid #e8e8e8;
  background-color: #fafafa;
  
  h3 {
    margin: 0;
    font-size: 16px;
    color: #333;
    font-weight: 500;
  }
}

.radio-group-wrapper {
  display: flex;
  align-items: center;
  padding-bottom: 7px;
}

.meeting-attachment-section {
  border-top: 1px solid #e8e8e8;
  margin-top: 16px;
  padding-top: 16px;
}

.attachment-header {
  margin-bottom: 12px;
  
  h4 {
    margin: 0;
    font-size: 14px;
    color: #333;
    font-weight: 500;
  }
}

.attachment-content {
  margin-top: 8px;
}

/deep/ .ant-table-wrapper .ant-table-thead>tr>th,
.ant-table-wrapper .ant-table-thead>tr>td {
  font-size: 14px;
  font-family: PingFang SC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(10, 33, 46, 1);
  background-color: rgba(239, 240, 245, 1);
}

/deep/.ant-table-wrapper .ant-table:not(.ant-table-bordered) .ant-table-tbody>tr {
  color: rgba(104, 118, 126, 1);
}

/deep/ .ant-table-wrapper .ant-table-thead>tr>th:not(:last-child):not(.ant-table-selection-column):not(.ant-table-row-expand-icon-cell):not([colspan])::before,
.ant-table-wrapper .ant-table-thead>tr>td:not(:last-child):not(.ant-table-selection-column):not(.ant-table-row-expand-icon-cell):not([colspan])::before {
  width: 0px;
}
</style>